(() => {
  const head = document.querySelector('head');
  const hostname = `${window.location.protocol}//${window.location.host}`;
  const queuedResources = new Map();
  const loadedResources = [];
  const preloadedResources = [];
  const prefetchedResources = [];

  window.swinger = {
    ...window.swinger,
    resourceLoader: {
      script(urls, callback, extraAttributes) {
        if (!Array.isArray(urls)) {
          urls = [urls];
        }

        let loadedCount = 0;
        const resolve = () => {
          loadedCount += 1;
          if (loadedCount < urls.length) {
            return;
          }
          if (callback) {
            callback();
          }
        };

        urls.forEach((url) => {
          if (loadedResources.indexOf(url) > -1) {
            resolve();
            return;
          }

          if (queuedResources.has(url)) {
            const script = queuedResources.get(url);

            script.addEventListener('load', () => {
              resolve();
            });

            return;
          }

          const script = document.createElement('script');

          queuedResources.set(url, script);

          script.addEventListener('load', () => {
            loadedResources.push(url);
            resolve();
          });

          if (extraAttributes) {
            Object.keys(extraAttributes).forEach((key) => {
              script.setAttribute(key, extraAttributes[key]);
            });
          }

          script.async = true;
          script.src = url;

          head.appendChild(script);
        });
      },
      module(urls, callback, extraAttributes) {
        if (!Array.isArray(urls)) {
          urls = [urls];
        }

        let loadedCount = 0;
        const resolve = () => {
          loadedCount += 1;
          if (loadedCount < urls.length) {
            return;
          }
          if (callback) {
            callback();
          }
        };

        urls.forEach((url) => {
          if (loadedResources.indexOf(url) > -1) {
            resolve();
            return;
          }

          if (queuedResources.has(url)) {
            const script = queuedResources.get(url);

            script.addEventListener('load', () => {
              resolve();
            });

            return;
          }

          const script = document.createElement('script');
          script.setAttribute('type', 'module');

          queuedResources.set(url, script);

          script.addEventListener('load', () => {
            loadedResources.push(url);
            resolve();
          });

          if (extraAttributes) {
            Object.keys(extraAttributes).forEach((key) => {
              script.setAttribute(key, extraAttributes[key]);
            });
          }

          script.async = true;
          script.src = url;

          head.appendChild(script);
        });
      },
      stylesheet(url, extraAttributes) {
        if (queuedResources.has(url)) {
          return;
        }

        const stylesheet = document.createElement('link');

        queuedResources.set(url, stylesheet);

        if (extraAttributes) {
          Object.keys(extraAttributes).forEach((key) => {
            stylesheet.setAttribute(key, extraAttributes.key);
          });
        }

        stylesheet.rel = 'stylesheet';
        stylesheet.href = url;

        head.appendChild(stylesheet);
      },
      preload(url, as, sameOrigin) {
        if (preloadedResources.indexOf(url) > -1) {
          return;
        }

        if (!!sameOrigin && !url.startsWith(hostname)) {
          return;
        }

        const preload = document.createElement('link');

        preload.rel = 'preload';
        preload.href = url;
        preload.as = as;

        document.querySelector('body').appendChild(preload);
        preloadedResources.push(url);
      },
      prefetch(url, sameOrigin) {
        if (prefetchedResources.indexOf(url) > -1) {
          return;
        }

        if (!!sameOrigin && !url.startsWith(hostname)) {
          return;
        }

        const prefetch = document.createElement('link');

        prefetch.rel = 'prefetch';
        prefetch.href = url;

        document.querySelector('body').appendChild(prefetch);
        prefetchedResources.push(url);
      },
    },
  };
})();
